import React, { ReactNode } from 'react';
import styles from './index.module.css';

interface IProps {
	children: ReactNode;
}

export const AppContainer = ({children}: IProps) => (
	<div className={styles.appContainer}>
		{children}
	</div>
);
